import Game, { GAMESTATES } from "../../model/game";

export function setGameState(setState: React.Dispatch<React.SetStateAction<Game>>, gameState: GAMESTATES): void {
    setState((state) => ({ ...state, state: gameState }));
}

export function setGameInfo(
    setState: React.Dispatch<React.SetStateAction<Game>>, question: string, options: string[], duration: number): void {
    setState((state) => ({
        ...state, question: question, options: options, duration: duration,
    }));
}

export function incrementQuestionNumber(
    setState: React.Dispatch<React.SetStateAction<Game>>): void {
    setState((state) => ({ ...state, questionNumber: state.questionNumber + 1 }));
}

export function incrementPercentage(
    setState: React.Dispatch<React.SetStateAction<Game>>,
    inc1: number,
    inc2: number): void {
    setState((state) => ({ ...state, percentage1: state.percentage1 + inc1, percentage2: state.percentage2 + inc2 }));
}
